<template>
    <div class="home">
        <!--<img alt="Vue logo" src="https://cdn.storekit.com/wp-content/uploads/2016/07/logo-3.png" class="mb-4 ml-auto mr-auto">-->
        <div class="flex flex-col center">

            <div class="bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 shadow-md" role="alert" >
                <div class="flex">
                    <div class="py-1"><svg class="fill-current h-6 w-6 text-teal-500 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/></svg></div>
                    <div>
                        <p class="font-bold">The transaction timed out.</p>
                        <p class="text-sm">Closing in {{closingIn}}s, you can then try again.</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import sendToVend from './../js/vendMessages'

    export default {
        name: "TimedOut",
        data() {
            return {
                closingIn: 5
            }
        },
        created() {
            this.countDownTimer();
            setTimeout(()=> {
                this.closeWindow();
            },5000);
        },
        methods: {
            closeWindow() {
                sendToVend("DECLINE")
            },
            countDownTimer() {
                if(this.closingIn > 0) {
                    setTimeout(() => {
                        this.closingIn -= 1
                        this.countDownTimer()
                    }, 1000)
                }
            }
        }
    }
</script>

<style scoped>

</style>